export class SaveGigotProductResultModel {
    private _closeDialog: boolean;
    private _success : boolean;
    private _message : string;


    constructor(closeDialog: boolean, success?: boolean,  message = '[Empty Message]') {
        this._closeDialog = closeDialog;
        this._success = success;
        this._message = message;
    }

    public isSuccess() : boolean {
        return this._success;
    }


    public getMessage() : string {
        return this._message;
    }

    public isCloseDialog(): boolean {
        return this._closeDialog;
    }
}
